// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--1dLHs","row":"a10a3f92e9--row--1wxxf","price":"a10a3f92e9--price--dhSDS"};